import { useMemo } from 'react'
import { Outlet } from 'react-router'
import { RBACProvider } from '@/components/rbac/rbac-provider'
import {
  TOTAL_SERVICES_QUERY,
  USER_COMPANIES_QUERY,
  USER_PERMISSIONS_QUERY,
} from '@/components/root/gql'
import { QueryRefsContext } from '@/components/root/query-refs-context'
import { SuperLayout } from '@/components/super-layout'
import { SidebarProvider } from '@/components/sv/sidebar'
import { useBackgroundQuery } from '@/lib/hooks'
import type {
  TotalServicesQuery,
  TotalServicesQueryVariables,
  UserCompaniesQuery,
  UserCompaniesQueryVariables,
  UserPermissionsQuery,
  UserPermissionsQueryVariables,
} from '@/components/root/gql.types.gen'

export const SuperRootContent = () => {
  const [userCompaniesQueryRef] = useBackgroundQuery<
    UserCompaniesQuery,
    UserCompaniesQueryVariables
  >(USER_COMPANIES_QUERY)
  const [userPermissionsQueryRef] = useBackgroundQuery<
    UserPermissionsQuery,
    UserPermissionsQueryVariables
  >(USER_PERMISSIONS_QUERY, {
    variables: {
      idCompany: '',
    },
  })
  const [totalServicesQueryRef] = useBackgroundQuery<
    TotalServicesQuery,
    TotalServicesQueryVariables
  >(TOTAL_SERVICES_QUERY, {
    variables: {
      idCompany: '',
    },
  })

  const queryRefsContext = useMemo(
    () => ({
      userCompaniesQueryRef,
      userPermissionsQueryRef,
      totalServicesQueryRef,
    }),
    [userCompaniesQueryRef, userPermissionsQueryRef, totalServicesQueryRef]
  )

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    <QueryRefsContext.Provider value={queryRefsContext}>
      <RBACProvider>
        <SidebarProvider>
          <SuperLayout>
            <Outlet />
          </SuperLayout>
        </SidebarProvider>
      </RBACProvider>
    </QueryRefsContext.Provider>
  )
}
